<ion-app>
  <app-updates-notification></app-updates-notification>
  <app-notification-alert></app-notification-alert>
  <app-toast-notifications [toastSettings]="appToastNotifications$ | ngrxPush"></app-toast-notifications>

  <app-side-menu></app-side-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
